import React from "react";
import BCLLoading from "../../../components/common/Loading/BCLLoading";

export default function Feedback(props) {
    return (
        <div className="feedback-main">  
            <div className="feedback-container">
                <div className="feedback-header">
                    <div className="header-title">
                        <p><span className="header-light">{props.success_message}, </span>{props.userFirstName}<span className="header-light">!</span><br /><span className="header-bold">{props.feedbackQuestion}</span></p>
                    </div>
            </div>
            
            <div className="feedback-instruction">
                {props.chooseAllText}
            </div>

            {props.feedbackOptions != null ? 
                 <div className="feedback-options">  
                    {props.feedbackOptions}
                 </div> : ''
            }
           
            <div className="feedback-textbox">
                <textarea  placeholder={props.translations.data["FEEDBACK.TYPE_HERE"]} 
                           value={props.otherFeedbackText} 
                           onChange={props.feedbackTextareaOnChange}
                           disabled={props.feedbackTextareaDisabled}/> 
            </div>
            
            {!props.loadingThankyouPage ? 
                <div className="button-box">
                    {props.submitButton} 
                </div> : 
                <BCLLoading /> 
            }
        </div>    
    </div>
                        
    )
}